/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __values } from "tslib";
import { DomainChart } from "./DomainChart";
import { fromEnum, enumGetBox, markType } from "igniteui-react-core";
import { HorizontalAlignment_$type } from "igniteui-react-core";
import { VerticalAlignment_$type } from "igniteui-react-core";
import { Visibility_$type } from "igniteui-react-core";
import { YAxisLabelLocation_$type } from "./YAxisLabelLocation";
import { XAxisLabelLocation_$type } from "./XAxisLabelLocation";
import { AxisLabelSettings } from "./AxisLabelSettings";
import { AxisDefaults } from "./AxisDefaults";
import { TitleSettings } from "./TitleSettings";
import { ScalerParams } from "./ScalerParams";
import { DeviceUtils } from "igniteui-react-core";
/**
 * @hidden
 */
var XYChart = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XYChart, _super);
    function XYChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.vi = null;
        _this.vj = null;
        _this.vz = 0;
        _this.v1 = 5;
        _this.v0 = 0;
        _this.vy = 5;
        _this.wg = 5;
        _this.wi = 0;
        _this.wh = 5;
        _this.wf = 0;
        _this.aa9 = null;
        _this.abg = null;
        _this.aa7 = null;
        _this.aa8 = null;
        _this.wa = 0;
        _this.wr = 0;
        _this.v9 = NaN;
        _this.wq = NaN;
        _this.wc = NaN;
        _this.wt = NaN;
        _this.wb = NaN;
        _this.ws = NaN;
        _this.v8 = NaN;
        _this.wp = NaN;
        _this.abf = null;
        _this.abm = null;
        _this.x1 = null;
        _this.x5 = null;
        _this.x3 = null;
        _this.x7 = null;
        _this.xw = null;
        _this.xx = null;
        _this.aba = null;
        _this.abh = null;
        _this.v2 = DeviceUtils.g(1);
        _this.wj = DeviceUtils.g(1);
        _this.v3 = DeviceUtils.g(1);
        _this.wk = DeviceUtils.g(1);
        _this.abc = null;
        _this.abj = null;
        _this.abd = null;
        _this.abk = null;
        _this.v4 = DeviceUtils.g(1);
        _this.wl = DeviceUtils.g(1);
        _this.v5 = DeviceUtils.g(8);
        _this.wm = 0;
        _this.abe = null;
        _this.abl = null;
        _this.v6 = DeviceUtils.g(1);
        _this.wn = DeviceUtils.g(1);
        _this.x2 = null;
        _this.x6 = null;
        _this.abb = null;
        _this.abi = null;
        _this.vx = 0;
        _this.we = 0;
        _this.vw = NaN;
        _this.wd = NaN;
        _this.v7 = 0;
        _this.wo = -90;
        _this.vs = false;
        _this.vt = false;
        _this.aa2 = 1;
        _this.ab5 = 1;
        _this.aa1 = 1;
        _this.aa3 = 2;
        _this.ab3 = 0;
        _this.ab4 = 1;
        _this.ab9 = 0;
        _this.aca = 0;
        _this.vq = 4;
        _this.vo = 4;
        _this.x0 = null;
        _this.vc = null;
        _this.x4 = null;
        _this.vd = null;
        return _this;
    }
    XYChart.prototype.provideContainer = function (a) {
        if (a != null) {
            var b = this.vg();
            var c = this.vh();
            if (b != null) {
                b.provideRenderer(a);
            }
            if (c != null) {
                c.provideRenderer(a);
            }
        }
        _super.prototype.provideContainer.call(this, a);
    };
    XYChart.prototype.rr = function () {
        _super.prototype.rr.call(this);
        var a = this.vg();
        var b = this.vh();
        if (a != null && a.ay != null) {
            this.abp = a.ay.textColor;
        }
        if (b != null && b.ay != null) {
            this.abw = b.ay.textColor;
        }
        this.abu = AxisDefaults.j;
        this.ab1 = AxisDefaults.j;
        this.abq = AxisDefaults.h;
        this.abx = AxisDefaults.h;
        this.abt = AxisDefaults.g;
        this.ab0 = AxisDefaults.g;
    };
    XYChart.prototype.se = function (a, b, c) {
        var _this = this;
        _super.prototype.se.call(this, a, b, c);
        switch (a) {
            case "XAxisLabelLeftMargin":
                this.aat(function (d) { return d.leftMargin = _this.w1; });
                break;
            case "XAxisLabelTopMargin":
                this.aat(function (d) { return d.topMargin = _this.w3; });
                break;
            case "XAxisLabelRightMargin":
                this.aat(function (d) { return d.rightMargin = _this.w2; });
                break;
            case "XAxisLabelBottomMargin":
                this.aat(function (d) { return d.bottomMargin = _this.w0; });
                break;
            case "YAxisLabelLeftMargin":
                this.aay(function (d) { return d.leftMargin = _this.xi; });
                break;
            case "YAxisLabelTopMargin":
                this.aay(function (d) { return d.topMargin = _this.xk; });
                break;
            case "YAxisLabelRightMargin":
                this.aay(function (d) { return d.rightMargin = _this.xj; });
                break;
            case "YAxisLabelBottomMargin":
                this.aay(function (d) { return d.bottomMargin = _this.xh; });
                break;
            case "ActualItemsSource":
            case "ShouldDisplayMockData":
            case "ShouldUseSkeletonStyleForMockData":
                this.abn = this.uj(this.abp);
                this.abo = this.uj(this.abw);
                break;
            case "XAxisLabelTextColor":
                this.abn = this.uj(this.abp);
                break;
            case "YAxisLabelTextColor":
                this.abo = this.uj(this.abw);
                break;
            case "ActualXAxisLabelTextColor":
                this.aat(function (d) { return d.textColor = _this.abn; });
                break;
            case "ActualYAxisLabelTextColor":
                this.aay(function (d) { return d.textColor = _this.abo; });
                break;
            case "XAxisTitleMargin":
                this.aav(function (d) { return d.margin = _this.xc; });
                break;
            case "YAxisTitleMargin":
                this.aa0(function (d) { return d.margin = _this.xt; });
                break;
            case "XAxisTitleLeftMargin":
                this.aav(function (d) { return d.leftMargin = _this.xb; });
                break;
            case "YAxisTitleLeftMargin":
                this.aa0(function (d) { return d.leftMargin = _this.xs; });
                break;
            case "XAxisTitleTopMargin":
                this.aav(function (d) { return d.topMargin = _this.xe; });
                break;
            case "YAxisTitleTopMargin":
                this.aa0(function (d) { return d.topMargin = _this.xv; });
                break;
            case "XAxisTitleRightMargin":
                this.aav(function (d) { return d.rightMargin = _this.xd; });
                break;
            case "YAxisTitleRightMargin":
                this.aa0(function (d) { return d.rightMargin = _this.xu; });
                break;
            case "XAxisTitleBottomMargin":
                this.aav(function (d) { return d.bottomMargin = _this.xa; });
                break;
            case "YAxisTitleBottomMargin":
                this.aa0(function (d) { return d.bottomMargin = _this.xr; });
                break;
            case "XAxisTitleTextColor":
                this.aav(function (d) { return d.textColor = _this.abv; });
                break;
            case "YAxisTitleTextColor":
                this.aa0(function (d) { return d.textColor = _this.ab2; });
                break;
            case "XAxisFormatLabel":
                this.aar(function (d) { return d.at = _this.vk; });
                break;
            case "YAxisFormatLabel":
                this.aaw(function (d) { return d.at = _this.vl; });
                break;
        }
    };
    Object.defineProperty(XYChart.prototype, "vk", {
        get: function () {
            return this.vi;
        },
        set: function (a) {
            var b = this.vk;
            if (a != b) {
                this.vi = a;
                this.sd("XAxisFormatLabel", b, this.vk);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "vl", {
        get: function () {
            return this.vj;
        },
        set: function (a) {
            var b = this.vl;
            if (a != b) {
                this.vj = a;
                this.sd("YAxisFormatLabel", b, this.vl);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w1", {
        get: function () {
            return this.vz;
        },
        set: function (a) {
            var b = this.w1;
            if (a != b) {
                this.vz = a;
                this.sd("XAxisLabelLeftMargin", b, this.w1);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w3", {
        get: function () {
            return this.v1;
        },
        set: function (a) {
            var b = this.w3;
            if (a != b) {
                this.v1 = a;
                this.sd("XAxisLabelTopMargin", b, this.w3);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w2", {
        get: function () {
            return this.v0;
        },
        set: function (a) {
            var b = this.w2;
            if (a != b) {
                this.v0 = a;
                this.sd("XAxisLabelRightMargin", b, this.w2);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w0", {
        get: function () {
            return this.vy;
        },
        set: function (a) {
            var b = this.w0;
            if (a != b) {
                this.vy = a;
                this.sd("XAxisLabelBottomMargin", b, this.w0);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xi", {
        get: function () {
            return this.wg;
        },
        set: function (a) {
            var b = this.xi;
            if (a != b) {
                this.wg = a;
                this.sd("YAxisLabelLeftMargin", b, this.xi);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xk", {
        get: function () {
            return this.wi;
        },
        set: function (a) {
            var b = this.xk;
            if (a != b) {
                this.wi = a;
                this.sd("YAxisLabelTopMargin", b, this.xk);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xj", {
        get: function () {
            return this.wh;
        },
        set: function (a) {
            var b = this.xj;
            if (a != b) {
                this.wh = a;
                this.sd("YAxisLabelRightMargin", b, this.xj);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xh", {
        get: function () {
            return this.wf;
        },
        set: function (a) {
            var b = this.xh;
            if (a != b) {
                this.wf = a;
                this.sd("YAxisLabelBottomMargin", b, this.xh);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abp", {
        get: function () {
            return this.aa9;
        },
        set: function (a) {
            var b = this.abp;
            if (a != b) {
                this.aa9 = a;
                this.sd("XAxisLabelTextColor", b, this.abp);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abw", {
        get: function () {
            return this.abg;
        },
        set: function (a) {
            var b = this.abw;
            if (a != b) {
                this.abg = a;
                this.sd("YAxisLabelTextColor", b, this.abw);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abn", {
        get: function () {
            return this.aa7;
        },
        set: function (a) {
            var b = this.aa7;
            if (a != b) {
                this.aa7 = a;
                this.sd("ActualXAxisLabelTextColor", b, this.abn);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abo", {
        get: function () {
            return this.aa8;
        },
        set: function (a) {
            var b = this.aa8;
            if (a != b) {
                this.aa8 = a;
                this.sd("ActualYAxisLabelTextColor", b, this.abo);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xc", {
        get: function () {
            return this.wa;
        },
        set: function (a) {
            var b = this.xc;
            if (a != b) {
                this.wa = a;
                this.sd("XAxisTitleMargin", b, this.xc);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xt", {
        get: function () {
            return this.wr;
        },
        set: function (a) {
            var b = this.xt;
            if (a != b) {
                this.wr = a;
                this.sd("YAxisTitleMargin", b, this.xt);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xb", {
        get: function () {
            return this.v9;
        },
        set: function (a) {
            var b = this.xb;
            if (a != b) {
                this.v9 = a;
                this.sd("XAxisTitleLeftMargin", b, this.xb);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xs", {
        get: function () {
            return this.wq;
        },
        set: function (a) {
            var b = this.xs;
            if (a != b) {
                this.wq = a;
                this.sd("YAxisTitleLeftMargin", b, this.xs);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xe", {
        get: function () {
            return this.wc;
        },
        set: function (a) {
            var b = this.xe;
            if (a != b) {
                this.wc = a;
                this.sd("XAxisTitleTopMargin", b, this.xe);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xv", {
        get: function () {
            return this.wt;
        },
        set: function (a) {
            var b = this.xv;
            if (a != b) {
                this.wt = a;
                this.sd("YAxisTitleTopMargin", b, this.xv);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xd", {
        get: function () {
            return this.wb;
        },
        set: function (a) {
            var b = this.xd;
            if (a != b) {
                this.wb = a;
                this.sd("XAxisTitleRightMargin", b, this.xd);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xu", {
        get: function () {
            return this.ws;
        },
        set: function (a) {
            var b = this.xu;
            if (a != b) {
                this.ws = a;
                this.sd("YAxisTitleRightMargin", b, this.xu);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xa", {
        get: function () {
            return this.v8;
        },
        set: function (a) {
            var b = this.xa;
            if (a != b) {
                this.v8 = a;
                this.sd("XAxisTitleBottomMargin", b, this.xa);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xr", {
        get: function () {
            return this.wp;
        },
        set: function (a) {
            var b = this.xr;
            if (a != b) {
                this.wp = a;
                this.sd("YAxisTitleBottomMargin", b, this.xr);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abv", {
        get: function () {
            return this.abf;
        },
        set: function (a) {
            var b = this.abv;
            if (a != b) {
                this.abf = a;
                this.sd("XAxisTitleTextColor", b, this.abv);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "ab2", {
        get: function () {
            return this.abm;
        },
        set: function (a) {
            var b = this.ab2;
            if (a != b) {
                this.abm = a;
                this.sd("YAxisTitleTextColor", b, this.ab2);
            }
        },
        enumerable: false,
        configurable: true
    });
    XYChart.prototype.sf = function (a, b, c) {
        var _this = this;
        _super.prototype.sf.call(this, a, b, c);
        switch (a) {
            case "XAxisLabelTextStyle":
                this.aat(function (d) { return d.textStyle = _this.yp; });
                break;
            case "YAxisLabelTextStyle":
                this.aay(function (d) { return d.textStyle = _this.zu; });
                break;
            case "XAxisTitleTextStyle":
                this.aav(function (d) { return d.textStyle = _this.zd; });
                break;
            case "YAxisTitleTextStyle":
                this.aa0(function (d) { return d.textStyle = _this.aai; });
                break;
        }
    };
    Object.defineProperty(XYChart.prototype, "yp", {
        get: function () {
            return this.x1;
        },
        set: function (a) {
            var b = this.yp;
            if (a != b) {
                this.x1 = a;
                this.sd("XAxisLabelTextStyle", b, this.yp);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "zu", {
        get: function () {
            return this.x5;
        },
        set: function (a) {
            var b = this.zu;
            if (a != b) {
                this.x5 = a;
                this.sd("YAxisLabelTextStyle", b, this.zu);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "zd", {
        get: function () {
            return this.x3;
        },
        set: function (a) {
            var b = this.zd;
            if (a != b) {
                this.x3 = a;
                this.sd("XAxisTitleTextStyle", b, this.zd);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "aai", {
        get: function () {
            return this.x7;
        },
        set: function (a) {
            var b = this.aai;
            if (a != b) {
                this.x7 = a;
                this.sd("YAxisTitleTextStyle", b, this.aai);
            }
        },
        enumerable: false,
        configurable: true
    });
    XYChart.prototype.aao = function (a) {
        var _this = this;
        this.aal(a, function (b) { return b.leftMargin = _this.w1; });
        this.aal(a, function (b) { return b.topMargin = _this.w3; });
        this.aal(a, function (b) { return b.rightMargin = _this.w2; });
        this.aal(a, function (b) { return b.bottomMargin = _this.w0; });
        this.aal(a, function (b) { return b.textColor = _this.abn; });
        this.aam(a, function (b) { return b.textColor = _this.abv; });
        this.aam(a, function (b) { return b.leftMargin = _this.xb; });
        this.aam(a, function (b) { return b.topMargin = _this.xe; });
        this.aam(a, function (b) { return b.rightMargin = _this.xd; });
        this.aam(a, function (b) { return b.bottomMargin = _this.xa; });
        this.aal(a, function (b) { return b.textStyle = _this.yp; });
        this.aam(a, function (b) { return b.textStyle = _this.zd; });
    };
    XYChart.prototype.aaq = function (a) {
        var _this = this;
        this.aal(a, function (b) { return b.leftMargin = _this.xi; });
        this.aal(a, function (b) { return b.topMargin = _this.xk; });
        this.aal(a, function (b) { return b.rightMargin = _this.xj; });
        this.aal(a, function (b) { return b.bottomMargin = _this.xh; });
        this.aal(a, function (b) { return b.textColor = _this.abo; });
        this.aam(a, function (b) { return b.textColor = _this.ab2; });
        this.aam(a, function (b) { return b.leftMargin = _this.xs; });
        this.aam(a, function (b) { return b.topMargin = _this.xv; });
        this.aam(a, function (b) { return b.rightMargin = _this.xu; });
        this.aam(a, function (b) { return b.bottomMargin = _this.xr; });
        this.aal(a, function (b) { return b.textStyle = _this.zu; });
        this.aam(a, function (b) { return b.textStyle = _this.aai; });
    };
    XYChart.prototype.sw = function (a) {
        var b = this.ba(a);
        var c = this.cw(a, b);
        if (c == null) {
            return;
        }
        c.itemsSource = a.data;
        c.name = this.nz(a);
        c.title = this.n0(a, b);
        this.dataChart.series.add(c);
    };
    XYChart.prototype.aar = function (a) {
        this.aas(a, null);
    };
    XYChart.prototype.aas = function (a, b) {
        a(this.vg());
    };
    XYChart.prototype.aax = function (a, b) {
        a(this.vh());
    };
    XYChart.prototype.aaw = function (a) {
        this.aax(a, true);
    };
    XYChart.prototype.rb = function (a, b) {
        this.aar(a);
        this.aax(a, b);
    };
    XYChart.prototype.aav = function (a) {
        this.aam(this.vg(), a);
    };
    XYChart.prototype.aa0 = function (a) {
        this.aam(this.vh(), a);
    };
    XYChart.prototype.aay = function (a) {
        this.aal(this.vh(), a);
    };
    XYChart.prototype.aat = function (a) {
        this.aal(this.vg(), a);
    };
    XYChart.prototype.wu = function (a) {
        var b = this.vg();
        return b.ei(a, new ScalerParams(1, this.ur, this.uq, b.cg));
    };
    XYChart.prototype.ww = function (a) {
        var b = this.vg();
        return b.el(a, new ScalerParams(1, this.ur, this.uq, b.cg));
    };
    XYChart.prototype.wv = function (a) {
        var b = this.vh();
        return b.ei(a, new ScalerParams(1, this.ur, this.uq, b.cg));
    };
    XYChart.prototype.wx = function (a) {
        var b = this.vh();
        return b.el(a, new ScalerParams(1, this.ur, this.uq, b.cg));
    };
    XYChart.prototype.st = function (a) {
        _super.prototype.st.call(this, a);
        if (a == null) {
            return;
        }
        if (a.axes != null) {
            var b = this.vg();
            var c = this.vh();
            if (a.axes.contains(b)) {
                a.axes.remove(b);
            }
            if (a.axes.contains(c)) {
                a.axes.remove(c);
            }
        }
    };
    XYChart.ya = function (a, b) {
        var e_1, _a;
        try {
            for (var _b = __values(fromEnum(b)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                var d = c.findMatchingHint(16);
                if (d != null) {
                    var e = d.path;
                    return e;
                }
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        return null;
    };
    XYChart.prototype.rm = function (a) {
        _super.prototype.rm.call(this, a);
        if (a == this.dataChart) {
            this.dataChart.axes.add(this.vg());
            this.dataChart.axes.add(this.vh());
        }
    };
    XYChart.prototype.aan = function (a) {
        var _this = this;
        if (a != null && this.ju != null && a.fk == null) {
            a.provideRenderer(this.ju);
        }
        a.jv = this.abq;
        a.eq = this.w4;
        a.jw = this.abr;
        a.et = this.w5;
        a.jy = this.abt;
        a.ff = this.w6;
        a.jx = this.abs;
        a.fg = this.w7;
        a.jz = this.abu;
        a.fh = this.w8;
        a.c3 = true;
        a.ct = this.f0;
        a.cv = this.f0;
        var b = a == this.vg();
        if (b) {
            a.g5 = this.y4;
        }
        a.fz = this.xy;
        a.gf = this.yg;
        a.ag = this.ve;
        this.aal(a, function (c) { return c.angle = _this.wz; });
        this.aal(a, function (c) {
            if (c.extent != _this.wy) {
                c.extent = _this.wy;
            }
        });
        this.aal(a, function (c) { return c.horizontalAlignment = _this.aa4; });
        this.aal(a, function (c) { return c.verticalAlignment = _this.ab6; });
        this.aal(a, function (c) { return c.visibility = _this.acb; });
        this.aal(a, function (c) { return c.location = _this.vm(_this.vp); });
        this.aam(a, function (c) { return c.horizontalAlignment = _this.aa5; });
        this.aam(a, function (c) { return c.angle = _this.w9; });
        this.aao(a);
    };
    XYChart.prototype.aap = function (a) {
        var _this = this;
        if (a == null) {
            return;
        }
        if (this.ju != null && a.fk == null) {
            a.provideRenderer(this.ju);
        }
        a.ct = this.f0;
        a.cv = this.f0;
        this.aal(a, function (b) { return b.angle = _this.xg; });
        this.aal(a, function (b) {
            if (b.extent != _this.xf) {
                b.extent = _this.xf;
            }
        });
        this.aal(a, function (b) { return b.horizontalAlignment = _this.aa6; });
        this.aal(a, function (b) { return b.verticalAlignment = _this.ab7; });
        this.aal(a, function (b) { return b.visibility = _this.acc; });
        this.aal(a, function (b) { return b.location = _this.vn(_this.vr); });
        this.aam(a, function (b) { return b.verticalAlignment = _this.ab8; });
        this.aam(a, function (b) { return b.angle = _this.xq; });
        a.jv = this.abx;
        a.eq = this.xl;
        a.jw = this.aby;
        a.et = this.xm;
        a.jy = this.ab0;
        a.ff = this.xn;
        a.jx = this.abz;
        a.fg = this.xo;
        a.jz = this.ab1;
        a.fh = this.xp;
        var b = a == this.vh();
        if (b) {
            a.g5 = this.z9;
        }
        a.gf = this.zl;
        a.ag = this.vf;
        this.aaq(a);
    };
    XYChart.prototype.rj = function () {
        _super.prototype.rj.call(this);
        this.aan(this.vg());
        this.aap(this.vh());
    };
    XYChart.prototype.aal = function (a, b) {
        if (a == null) {
            return;
        }
        if (a.ay == null) {
            a.ay = new AxisLabelSettings();
            a.ay.angle = a.d4();
            a.ay.bottomMargin = a.d5();
            a.ay.leftMargin = a.d6();
            a.ay.rightMargin = a.d7();
            a.ay.topMargin = a.d8();
            a.ay.horizontalAlignment = a.jq();
            a.ay.location = a.az();
            a.ay.verticalAlignment = a.kj();
        }
        b(a.ay);
    };
    XYChart.prototype.aam = function (a, b) {
        if (a == null) {
            return;
        }
        if (a.be == null) {
            a.be = new TitleSettings();
            a.be.bottomMargin = a.ea();
            a.be.leftMargin = a.eb();
            a.be.rightMargin = a.ec();
            a.be.topMargin = a.ed();
            a.be.location = a.a0();
            a.be.angle = a.d9();
            a.be.horizontalAlignment = a.jr();
            a.be.verticalAlignment = a.kk();
        }
        b(a.be);
    };
    XYChart.prototype.sd = function (a, b, c) {
        var _this = this;
        _super.prototype.sd.call(this, a, b, c);
        switch (a) {
            case "XAxisLabelAngle":
                this.aat(function (d) { return d.angle = _this.wz; });
                break;
            case "YAxisLabelAngle":
                this.aay(function (d) { return d.angle = _this.xg; });
                break;
            case "XAxisLabelHorizontalAlignment":
                this.aat(function (d) { return d.horizontalAlignment = _this.aa4; });
                break;
            case "YAxisLabelHorizontalAlignment":
                this.aay(function (d) { return d.horizontalAlignment = _this.aa6; });
                break;
            case "XAxisLabelVerticalAlignment":
                this.aat(function (d) { return d.verticalAlignment = _this.ab6; });
                break;
            case "YAxisLabelVerticalAlignment":
                this.aay(function (d) { return d.verticalAlignment = _this.ab7; });
                break;
            case "XAxisLabelVisibility":
                this.aat(function (d) { return d.visibility = _this.acb; });
                break;
            case "YAxisLabelVisibility":
                this.aay(function (d) { return d.visibility = _this.acc; });
                break;
            case "XAxisLabel":
                this.aar(function (d) { return d.fz = _this.xy; });
                break;
            case "YAxisLabel":
                this.aaw(function (d) { return d.fz = _this.xz; });
                break;
            case "XAxisLabelFormat":
                this.aar(function (d) { return d.gf = _this.yg; });
                break;
            case "XAxisLabelFormatSpecifiers":
                this.aar(function (d) { return d.ag = _this.ve; });
                break;
            case "YAxisLabelFormat":
                this.aaw(function (d) { return d.gf = _this.zl; });
                break;
            case "YAxisLabelFormatSpecifiers":
                this.aaw(function (d) { return d.ag = _this.vf; });
                break;
            case "XAxisTitleAngle":
                this.aav(function (d) { return d.angle = _this.w9; });
                break;
            case "YAxisTitleAngle":
                this.aa0(function (d) { return d.angle = _this.xq; });
                break;
            case "XAxisTitleAlignment":
                this.aav(function (d) { return d.horizontalAlignment = _this.aa5; });
                break;
            case "YAxisTitleAlignment":
                this.aa0(function (d) { return d.verticalAlignment = _this.ab8; });
                break;
            case "XAxisTitle":
                this.aar(function (d) { return d.g5 = _this.y4; });
                break;
            case "YAxisTitle":
                this.aax(function (d) { return d.g5 = _this.z9; }, false);
                break;
            case "XAxisMajorStroke":
                this.aas(function (d) { return d.jv = _this.abq; }, a);
                break;
            case "YAxisMajorStroke":
                this.aaw(function (d) { return d.jv = _this.abx; });
                break;
            case "XAxisMajorStrokeThickness":
                this.aas(function (d) { return d.eq = _this.w4; }, a);
                break;
            case "YAxisMajorStrokeThickness":
                this.aaw(function (d) { return d.eq = _this.xl; });
                break;
            case "XAxisMinorStroke":
                this.aar(function (d) { return d.jw = _this.abr; });
                break;
            case "YAxisMinorStroke":
                this.aaw(function (d) { return d.jw = _this.aby; });
                break;
            case "XAxisMinorStrokeThickness":
                this.aar(function (d) { return d.et = _this.w5; });
                break;
            case "YAxisMinorStrokeThickness":
                this.aaw(function (d) { return d.et = _this.xm; });
                break;
            case "XAxisTickLength":
                this.aar(function (d) { return d.fg = _this.w7; });
                break;
            case "YAxisTickLength":
                this.aaw(function (d) { return d.fg = _this.xo; });
                break;
            case "XAxisTickStroke":
                this.aar(function (d) { return d.jz = _this.abu; });
                break;
            case "YAxisTickStroke":
                this.aaw(function (d) { return d.jz = _this.ab1; });
                break;
            case "XAxisTickStrokeThickness":
                this.aar(function (d) { return d.fh = _this.w8; });
                break;
            case "YAxisTickStrokeThickness":
                this.aaw(function (d) { return d.fh = _this.xp; });
                break;
            case "XAxisStroke":
                this.aar(function (d) { return d.jy = _this.abt; });
                break;
            case "YAxisStroke":
                this.aaw(function (d) { return d.jy = _this.ab0; });
                break;
            case "XAxisStrokeThickness":
                this.aar(function (d) { return d.ff = _this.w6; });
                break;
            case "YAxisStrokeThickness":
                this.aaw(function (d) { return d.ff = _this.xn; });
                break;
            case "XAxisExtent":
                this.aat(function (d) { return d.extent = _this.wy; });
                break;
            case "YAxisExtent":
                this.aay(function (d) { return d.extent = _this.xf; });
                break;
            case "XAxisStrip":
                this.aar(function (d) { return d.jx = _this.abs; });
                break;
            case "YAxisStrip":
                this.aaw(function (d) { return d.jx = _this.abz; });
                break;
            case "XAxisInverted":
                this.aar(function (d) { return d.cg = _this.vu; });
                break;
            case "YAxisInverted":
                this.aaw(function (d) { return d.cg = _this.vv; });
                break;
            case "YAxisLabelLocation":
                this.aaz();
                break;
            case "XAxisLabelLocation":
                this.aau();
                break;
        }
    };
    XYChart.prototype.aaz = function () {
        var a = this.vn(this.vr);
        if (a == 2 || a == 7) {
            this.aa6 = 2;
        }
        else {
            this.aa6 = 0;
        }
        this.aay(function (b) { return b.location = a; });
    };
    XYChart.prototype.aau = function () {
        var a = this.vm(this.vp);
        if (a == 1 || a == 5) {
            this.ab6 = 0;
        }
        else {
            this.ab6 = 2;
        }
        this.aat(function (b) { return b.location = a; });
    };
    XYChart.prototype.vn = function (a) {
        if (a == 0) {
            return 2;
        }
        else if (a == 1) {
            return 3;
        }
        else if (a == 3) {
            return 7;
        }
        else if (a == 2) {
            return 6;
        }
        else {
            if (this.bz == 1) {
                return 3;
            }
            else {
                return 2;
            }
        }
    };
    XYChart.prototype.vm = function (a) {
        if (a == 1) {
            return 1;
        }
        else if (a == 0) {
            return 0;
        }
        else if (a == 3) {
            return 5;
        }
        else if (a == 2) {
            return 4;
        }
        else {
            return 1;
        }
    };
    Object.defineProperty(XYChart.prototype, "xy", {
        get: function () {
            return this.xw;
        },
        set: function (a) {
            var b = this.xy;
            if (a != b) {
                this.xw = a;
                this.sd("XAxisLabel", b, this.xy);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xz", {
        get: function () {
            return this.xx;
        },
        set: function (a) {
            var b = this.xz;
            if (a != b) {
                this.xx = a;
                this.sd("YAxisLabel", b, this.xz);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abq", {
        get: function () {
            return this.aba;
        },
        set: function (a) {
            var b = this.abq;
            if (a != b) {
                this.aba = a;
                this.sd("XAxisMajorStroke", b, this.abq);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abx", {
        get: function () {
            return this.abh;
        },
        set: function (a) {
            var b = this.abx;
            if (a != b) {
                this.abh = a;
                this.sd("YAxisMajorStroke", b, this.abx);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w4", {
        get: function () {
            return this.v2;
        },
        set: function (a) {
            var b = this.w4;
            if (a != b) {
                this.v2 = a;
                this.sd("XAxisMajorStrokeThickness", b, this.w4);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xl", {
        get: function () {
            return this.wj;
        },
        set: function (a) {
            var b = this.xl;
            if (a != b) {
                this.wj = a;
                this.sd("YAxisMajorStrokeThickness", b, this.xl);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w5", {
        get: function () {
            return this.v3;
        },
        set: function (a) {
            var b = this.w5;
            if (a != b) {
                this.v3 = a;
                this.sd("XAxisMinorStrokeThickness", b, this.w5);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xm", {
        get: function () {
            return this.wk;
        },
        set: function (a) {
            var b = this.xm;
            if (a != b) {
                this.wk = a;
                this.sd("YAxisMinorStrokeThickness", b, this.xm);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abs", {
        get: function () {
            return this.abc;
        },
        set: function (a) {
            var b = this.abs;
            if (a != b) {
                this.abc = a;
                this.sd("XAxisStrip", b, this.abs);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abz", {
        get: function () {
            return this.abj;
        },
        set: function (a) {
            var b = this.abz;
            if (a != b) {
                this.abj = a;
                this.sd("YAxisStrip", b, this.abz);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abt", {
        get: function () {
            return this.abd;
        },
        set: function (a) {
            var b = this.abt;
            if (a != b) {
                this.abd = a;
                this.sd("XAxisStroke", b, this.abt);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "ab0", {
        get: function () {
            return this.abk;
        },
        set: function (a) {
            var b = this.ab0;
            if (a != b) {
                this.abk = a;
                this.sd("YAxisStroke", b, this.ab0);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w6", {
        get: function () {
            return this.v4;
        },
        set: function (a) {
            var b = this.w6;
            if (a != b) {
                this.v4 = a;
                this.sd("XAxisStrokeThickness", b, this.w6);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xn", {
        get: function () {
            return this.wl;
        },
        set: function (a) {
            var b = this.xn;
            if (a != b) {
                this.wl = a;
                this.sd("YAxisStrokeThickness", b, this.xn);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w7", {
        get: function () {
            return this.v5;
        },
        set: function (a) {
            var b = this.w7;
            if (a != b) {
                this.v5 = a;
                this.sd("XAxisTickLength", b, this.w7);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xo", {
        get: function () {
            return this.wm;
        },
        set: function (a) {
            var b = this.xo;
            if (a != b) {
                this.wm = a;
                this.sd("YAxisTickLength", b, this.xo);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abu", {
        get: function () {
            return this.abe;
        },
        set: function (a) {
            var b = this.abu;
            if (a != b) {
                this.abe = a;
                this.sd("XAxisTickStroke", b, this.abu);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "ab1", {
        get: function () {
            return this.abl;
        },
        set: function (a) {
            var b = this.ab1;
            if (a != b) {
                this.abl = a;
                this.sd("YAxisTickStroke", b, this.ab1);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w8", {
        get: function () {
            return this.v6;
        },
        set: function (a) {
            var b = this.w8;
            if (a != b) {
                this.v6 = a;
                this.sd("XAxisTickStrokeThickness", b, this.w8);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xp", {
        get: function () {
            return this.wn;
        },
        set: function (a) {
            var b = this.xp;
            if (a != b) {
                this.wn = a;
                this.sd("YAxisTickStrokeThickness", b, this.xp);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "y4", {
        get: function () {
            return this.x2;
        },
        set: function (a) {
            var b = this.y4;
            if (a != b) {
                this.x2 = a;
                this.sd("XAxisTitle", b, this.y4);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "z9", {
        get: function () {
            return this.x6;
        },
        set: function (a) {
            var b = this.z9;
            if (a != b) {
                this.x6 = a;
                this.sd("YAxisTitle", b, this.z9);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "abr", {
        get: function () {
            return this.abb;
        },
        set: function (a) {
            var b = this.abr;
            if (a != b) {
                this.abb = a;
                this.sd("XAxisMinorStroke", b, this.abr);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "aby", {
        get: function () {
            return this.abi;
        },
        set: function (a) {
            var b = this.aby;
            if (a != b) {
                this.abi = a;
                this.sd("YAxisMinorStroke", b, this.aby);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "wz", {
        get: function () {
            return this.vx;
        },
        set: function (a) {
            var b = this.wz;
            if (a != b) {
                this.vx = a;
                this.sd("XAxisLabelAngle", b, this.wz);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xg", {
        get: function () {
            return this.we;
        },
        set: function (a) {
            var b = this.xg;
            if (a != b) {
                this.we = a;
                this.sd("YAxisLabelAngle", b, this.xg);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "wy", {
        get: function () {
            return this.vw;
        },
        set: function (a) {
            var b = this.wy;
            if (a != b) {
                this.vw = a;
                this.sd("XAxisExtent", b, this.wy);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xf", {
        get: function () {
            return this.wd;
        },
        set: function (a) {
            var b = this.xf;
            if (a != b) {
                this.wd = a;
                this.sd("YAxisExtent", b, this.xf);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "w9", {
        get: function () {
            return this.v7;
        },
        set: function (a) {
            var b = this.w9;
            if (a != b) {
                this.v7 = a;
                this.sd("XAxisTitleAngle", b, this.w9);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "xq", {
        get: function () {
            return this.wo;
        },
        set: function (a) {
            var b = this.xq;
            if (a != b) {
                this.wo = a;
                this.sd("YAxisTitleAngle", b, this.xq);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "vu", {
        get: function () {
            return this.vs;
        },
        set: function (a) {
            var b = this.vu;
            if (a != b) {
                this.vs = a;
                this.sd("XAxisInverted", b, this.vu);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "vv", {
        get: function () {
            return this.vt;
        },
        set: function (a) {
            var b = this.vv;
            if (a != b) {
                this.vt = a;
                this.sd("YAxisInverted", b, this.vv);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "aa5", {
        get: function () {
            return this.aa2;
        },
        set: function (a) {
            var b = this.aa5;
            if (a != b) {
                this.aa2 = a;
                this.sd("XAxisTitleAlignment", enumGetBox(HorizontalAlignment_$type, b), enumGetBox(HorizontalAlignment_$type, this.aa5));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "ab8", {
        get: function () {
            return this.ab5;
        },
        set: function (a) {
            var b = this.ab8;
            if (a != b) {
                this.ab5 = a;
                this.sd("YAxisTitleAlignment", enumGetBox(VerticalAlignment_$type, b), enumGetBox(VerticalAlignment_$type, this.ab8));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "aa4", {
        get: function () {
            return this.aa1;
        },
        set: function (a) {
            var b = this.aa4;
            if (a != b) {
                this.aa1 = a;
                this.sd("XAxisLabelHorizontalAlignment", enumGetBox(HorizontalAlignment_$type, b), enumGetBox(HorizontalAlignment_$type, this.aa4));
            }
        },
        enumerable: false,
        configurable: true
    });
    XYChart.prototype.get_aa6 = function () {
        return this.aa3;
    };
    XYChart.prototype.set_aa6 = function (a) {
        var b = this.aa6;
        if (a != b) {
            this.aa3 = a;
            this.sd("YAxisLabelHorizontalAlignment", enumGetBox(HorizontalAlignment_$type, b), enumGetBox(HorizontalAlignment_$type, this.aa6));
        }
    };
    Object.defineProperty(XYChart.prototype, "aa6", {
        get: function () {
            return this.get_aa6();
        },
        set: function (a) {
            this.set_aa6(a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "ab6", {
        get: function () {
            return this.ab3;
        },
        set: function (a) {
            var b = this.ab6;
            if (a != b) {
                this.ab3 = a;
                this.sd("XAxisLabelVerticalAlignment", enumGetBox(VerticalAlignment_$type, b), enumGetBox(VerticalAlignment_$type, this.ab6));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "ab7", {
        get: function () {
            return this.ab4;
        },
        set: function (a) {
            var b = this.ab7;
            if (a != b) {
                this.ab4 = a;
                this.sd("YAxisLabelVerticalAlignment", enumGetBox(VerticalAlignment_$type, b), enumGetBox(VerticalAlignment_$type, this.ab7));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "acb", {
        get: function () {
            return this.ab9;
        },
        set: function (a) {
            var b = this.acb;
            if (a != b) {
                this.ab9 = a;
                this.sd("XAxisLabelVisibility", enumGetBox(Visibility_$type, b), enumGetBox(Visibility_$type, this.acb));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "acc", {
        get: function () {
            return this.aca;
        },
        set: function (a) {
            var b = this.acc;
            if (a != b) {
                this.aca = a;
                this.sd("YAxisLabelVisibility", enumGetBox(Visibility_$type, b), enumGetBox(Visibility_$type, this.acc));
            }
        },
        enumerable: false,
        configurable: true
    });
    XYChart.prototype.get_vr = function () {
        return this.vq;
    };
    XYChart.prototype.set_vr = function (a) {
        var b = this.vr;
        if (a != b) {
            this.vq = a;
            this.sd("YAxisLabelLocation", enumGetBox(YAxisLabelLocation_$type, b), enumGetBox(YAxisLabelLocation_$type, this.vr));
        }
    };
    Object.defineProperty(XYChart.prototype, "vr", {
        get: function () {
            return this.get_vr();
        },
        set: function (a) {
            this.set_vr(a);
        },
        enumerable: false,
        configurable: true
    });
    XYChart.prototype.get_vp = function () {
        return this.vo;
    };
    XYChart.prototype.set_vp = function (a) {
        var b = this.vp;
        if (a != b) {
            this.vo = a;
            this.sd("XAxisLabelLocation", enumGetBox(XAxisLabelLocation_$type, b), enumGetBox(XAxisLabelLocation_$type, this.vp));
        }
    };
    Object.defineProperty(XYChart.prototype, "vp", {
        get: function () {
            return this.get_vp();
        },
        set: function (a) {
            this.set_vp(a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "yg", {
        get: function () {
            return this.x0;
        },
        set: function (a) {
            var b = this.x0;
            if (a != b) {
                this.x0 = a;
                this.sd("XAxisLabelFormat", b, this.x0);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "ve", {
        get: function () {
            return this.vc;
        },
        set: function (a) {
            var b = this.vc;
            if (a != b) {
                this.vc = a;
                this.sd("XAxisLabelFormatSpecifiers", b, this.vc);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "zl", {
        get: function () {
            return this.x4;
        },
        set: function (a) {
            var b = this.x4;
            if (a != b) {
                this.x4 = a;
                this.sd("YAxisLabelFormat", b, this.x4);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XYChart.prototype, "vf", {
        get: function () {
            return this.vd;
        },
        set: function (a) {
            var b = this.vd;
            if (a != b) {
                this.vd = a;
                this.sd("YAxisLabelFormatSpecifiers", b, this.vd);
            }
        },
        enumerable: false,
        configurable: true
    });
    XYChart.$t = markType(XYChart, 'XYChart', DomainChart.$);
    return XYChart;
}(DomainChart));
export { XYChart };
